import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import { getUserProfile } from '../actions';
import { getAllCentros } from '../actions/centro_actions';

import * as config from '../constants/configuration';
import userManager from '../userManager';

import { Typography } from '@material-ui/core';

import { GetKDfromString, HasKDpath, IsKD_Inventario } from '../KDgeneric'

//import { getEmpresas } from '../actions';

const styles = theme => ({
    img: {
        width: '100%',
        display: "block",
        marginBottom: "20px",
        marginTop: "100px"
    },
    button: {
        color: "white"
    }
});

class Main extends Component {

    /*  constructor(props){
         super(props);
         // this.state = {
         //     centrosListLoaded : false
         // }
     } */

    componentDidUpdate(prevProps) {
        if (config.AUTH) { // && centros
            // if ((this.props.user !== prevProps.user || this.props.centros.length > 0 ) && this.props.user) {
            //     //get user info
            //     this.props.getUserProfile(this.props.user.profile.sub);
            // }

            if (this.props.user && (this.props.user !== prevProps.user)) {
                this.props.getAllCentros();
            }
            else if (this.props.user && this.props.centros.length > 0 && this.props.centros !== prevProps.centros) {
                this.props.getUserProfile(this.props.user.profile.sub, window.location.kd);
            }

        }
    }

    componentDidMount() {
        // // if (this.props.user) { //get centros
        //     //this.props.getUserProfile(this.props.user.profile.sub);
        //     this.props.getAllCentros();
        // // }

        if (this.props.user) this.props.getAllCentros();
    }

    render() {

        const { classes } = this.props;

        const isKD = HasKDpath();
        let imagen = isKD ? "/Ilusiona_fav.png" : `${process.env.PUBLIC_URL}/${process.env.REACT_APP_CLIENT}.png`;

        if ( isKD )
        {
            let kd = GetKDfromString(window.location.pathname);
            document.title = kd.empresa;
            var link = document.querySelector("link[rel~='icon']");
            link.href = imagen;
        }
        
        if (!this.props.user) {
            return (
                <Grid container
                    direction="row"
                    justify="center"
                    alignItems="center">
                    <Grid container direction="row" justify="center"
                        alignItems="center" item xs={12} >
                        <Grid item xs={isKD ? 1 : 11} md={isKD ? 1 : 8} lg={isKD ? 1 : 4}>
                            <img
                                src={imagen}
                                className={classes.img}
                                alt={process.env.REACT_APP_CLIENT}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={11} md={8} lg={4}>
                        <Button fullWidth className={classes.button} variant="contained" color="primary" onClick={() => {
                            userManager.signinRedirect();
                        }}>Inicie sesión</Button>
                    </Grid>
                </Grid>
            );
        }
        else {
            return null;
        }
    };

};

Main.propTypes = {
    //state:
    user: PropTypes.object,
    //dispatch:
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        centros: state.centros.centros,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getUserProfile,
        getAllCentros
    }, dispatch);
};


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(Main));